<template>
   <svg width="17" height="18" viewBox="0 0 17 18" xmlns="http://www.w3.org/2000/svg">
     <path d="M15.17.72l1.69 1.68-6.75 6.74 6.75 6.75-1.69 1.68-6.74-6.74-6.74 6.74L0 15.9l6.74-6.75L0 2.4 1.69.72l6.74 6.74L15.17.72z"/>
   </svg>
</template>

<script>
export default {
   name: 'CloseIcon'
}
</script>